// src/data/game-themes.ts
import { GameThemeConfig } from './character-config';

// Cyberpunk theme
export const cyberpunkTheme: GameThemeConfig = {
  name: 'Cyberpunk',
  colors: {
    primary: '#00ffff', // Cyan
    secondary: '#ff00ff', // Magenta
    accent: '#ffd700', // Gold
    background: '#0a0f1c', // Deep space
    success: '#4cd137', // Green
    warning: '#ffa502', // Amber
    danger: '#e74c3c', // Red
    info: '#3498db', // Blue
  },
  fonts: {
    heading: 'Orbitron',
    body: 'Rajdhani',
    mono: 'JetBrains Mono',
  },
  elements: {
    borderRadius: '0.25rem',
    borderWidth: '1px',
    shadowSize: '0 0 20px rgba(0, 255, 255, 0.6)',
  },
};

// Fantasy theme
export const fantasyTheme: GameThemeConfig = {
  name: 'Fantasy',
  colors: {
    primary: '#8a5a44', // Brown
    secondary: '#61892f', // Forest green
    accent: '#c19a6b', // Gold brown
    background: '#2c3333', // Dark forest
    success: '#61892f', // Forest green
    warning: '#ffa200', // Orange
    danger: '#8b0000', // Dark red
    info: '#4682b4', // Steel blue
  },
  fonts: {
    heading: 'MedievalSharp',
    body: 'Metamorphous',
    mono: 'Courier New',
  },
  elements: {
    borderRadius: '0',
    borderWidth: '2px',
    shadowSize: '0 0 10px rgba(0, 0, 0, 0.5)',
  },
};

// Sci-fi theme
export const scifiTheme: GameThemeConfig = {
  name: 'Sci-Fi',
  colors: {
    primary: '#3498db', // Blue
    secondary: '#9b59b6', // Purple
    accent: '#f39c12', // Orange
    background: '#1a2037', // Deep blue
    success: '#2ecc71', // Green
    warning: '#f1c40f', // Yellow
    danger: '#e74c3c', // Red
    info: '#1abc9c', // Teal
  },
  fonts: {
    heading: 'Orbitron',
    body: 'Titillium Web',
    mono: 'Share Tech Mono',
  },
  elements: {
    borderRadius: '0.5rem',
    borderWidth: '1px',
    shadowSize: '0 0 15px rgba(0, 0, 0, 0.4)',
  },
};

// Default theme based on current configuration
export const defaultTheme: GameThemeConfig = {
  name: 'Default',
  colors: {
    primary: '#3498db', // Celestial-blue
    secondary: '#00ffff', // Mystic-cyan
    accent: '#ffd700', // Cosmic-gold
    background: '#1a2037', // Deep-space
    success: '#4cd137', // Ethereal-green
    warning: '#ffd700', // Cosmic-gold
    danger: '#e74c3c', // Crimson-force
    info: '#9b59b6', // Arcane-purple
  },
  fonts: {
    heading: 'Orbitron',
    body: 'Rajdhani',
    mono: 'JetBrains Mono',
  },
  elements: {
    borderRadius: '0.5rem',
    borderWidth: '1px',
    shadowSize: '0 0 20px rgba(0, 255, 255, 0.6)',
  },
};

// Available themes map
export const availableThemes: Record<string, GameThemeConfig> = {
  default: defaultTheme,
  cyberpunk: cyberpunkTheme,
  fantasy: fantasyTheme,
  scifi: scifiTheme,
};